export default class User {
  constructor(username, email, password,token,device_id) {
    this.username = username;
    this.email = email;
    this.password = password;
    this.token = token;
    this.device_id = device_id;
  }
}
